
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic06Static as ObiHydraulic06StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-06-static.js';
 
 
 

 
 export const ObiHydraulic06Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-06-static',
   elementClass: ObiHydraulic06StaticElement,
   events: {
     
   }
  });
 
 